import { memoize } from 'lodash';

// `lodash.memoize` takes the first parameter to create the cache key
const findBySlug = memoize(({ targetSlug }, entries) => {
    return entries.find(({ slug }) => slug === targetSlug);
});

/**
 * Get an entry from a list of entries using a slug
 * @param {IMapEntry[]} entries - The list of entries
 * @param {any} getters - A list of the module's getters
 * @return {IMapEntry} The search result
 */
export const getEntriesBySlug = ({ entries }) => (targetSlug, targetType) => {
    return findBySlug({ targetSlug, targetType }, entries);
};

/**
 * Get the active entry
 * @param {IProjectDataState} state - The vuex module's state
 * @param {any} getters - A list of the module's getters
 * @param {any} rootState - The vuex store's state
 * @return {IMapEntry} The active entry
 */
export const activeEntry = (state, getters, rootState) => {
    return getters.getEntriesBySlug(rootState.route.params.entry);
};
